import script from "./PortfolioCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioCard.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioCard.vue?vue&type=style&index=0&id=59d7c6bd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d7c6bd"]])

export default __exports__